import { reactive, ref, computed, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-952bb7ba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time-content"
};
const _hoisted_5 = {
  class: "time-select-content"
};
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时区", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时间段", -1));
const _hoisted_10 = {
  class: "filter-list product-filter"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "产品名称", -1));
const _hoisted_12 = {
  class: "appListPopover-content"
};
const _hoisted_13 = {
  class: "appListPopover-content-title"
};
const _hoisted_14 = {
  class: "inf-label"
};
const _hoisted_15 = {
  class: "inf-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_17 = {
  class: "filter-list product-filter"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "支付渠道", -1));
const _hoisted_19 = {
  class: "condition-content"
};
const _hoisted_20 = {
  class: "condition-select-content"
};
const _hoisted_21 = {
  class: "filter-list"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "工作室", -1));
const _hoisted_23 = {
  class: "filter-list"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "包名", -1));
const _hoisted_25 = {
  class: "filter-list"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "国家", -1));
const _hoisted_27 = {
  class: "filter-list"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "版本", -1));
const _hoisted_29 = {
  class: "filter-list"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "商品信息", -1));
const _hoisted_31 = {
  class: "right"
};
import IncomePermissionBadge from '@/components/IncomePermissionBadge.vue';
import dayjs from 'dayjs';
import { selectByDimensionType, selectDbtIdByStudioId, selectDimensionByDbtId } from '@/api/pay';
import { useStore } from '@/store';
import DbtDatePicker from '@/components/DbtDatePicker.vue';
import { getNode, detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import { DownOutlined } from '@ant-design/icons-vue';
import '@dbt/product-select/dist/style.css';
// 定义组件事件
export default /*#__PURE__*/_defineComponent({
  __name: 'RevenueHeader',
  emits: ['returnSearch'],
  setup(__props, {
    emit
  }) {
    // 时区选项列表
    const zoneList = [{
        label: '北京时间（UTC+8）',
        value: 'Asia/Shanghai'
      }, {
        label: '世界协调时间（UTC）',
        value: 'UTC'
      }, {
        label: '太平洋标准时间 (PST/UTC-8)',
        value: 'UTC-8'
      }, {
        label: '太平洋夏令时间 (PDT/UTC-7)',
        value: 'UTC-7'
      }],
      // 时间周期选项列表
      periodList = [{
        label: '天',
        value: 'day'
      }, {
        label: '周',
        value: 'week'
      }, {
        label: '月',
        value: 'month'
      }, {
        label: '总计',
        value: 'sum'
      }];
    // 时间相关的表单状态
    const formState = reactive({
      startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
      endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false // 是否使用服务器时间
    });
    // 各种筛选项的数据列表
    const appList = ref([]),
      // 应用列表
      channelList = ref([]),
      // 渠道列表
      regionList = ref([]),
      // 地区列表
      verList = ref([]),
      // 版本列表
      prodList = ref([]),
      // 产品列表
      timeZoneType = ref('Asia/Shanghai'),
      // 当前选择的时区
      datePeriod = ref('day'),
      // 当前选择的时间周期
      dbtIdList = ref([]),
      // 选中的应用ID列表
      appVersionList = ref([]),
      // 选中的版本列表
      payChnl = ref([]),
      // 选中的支付渠道列表
      proIdList = ref([]),
      // 选中的产品ID列表
      pkgIdList = ref([]),
      // 选中的包名ID列表
      regionIdList = ref([]),
      // 选中的地区ID列表
      studioList = ref(),
      // 工作室列表
      pkgList = ref(),
      // 包名列表
      studioChecked = ref([]),
      // 选中的工作室列表
      productSelectRef = ref(null),
      // 产品选择器引用
      studioSelectRef = ref(null),
      // 工作室选择器引用
      pkgSelectRef = ref(null),
      // 包名选择器引用
      chanlSelectRef = ref(null),
      // 渠道选择器引用
      regionSelectRef = ref(null),
      // 地区选择器引用
      versionSelectRef = ref(null),
      // 版本选择器引用
      prodSelectRef = ref(null),
      // 产品选择器引用
      isExpanded = ref(false); // 低频筛选项是否展开
    // 获取用户信息
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    // 获取应用数据
    const getAppData = async (autoCheck = false) => {
        try {
          const {
            code,
            data
          } = await selectDbtIdByStudioId(studioChecked.value, 'incoming');
          if (code === '0') {
            var _productSelectRef$val;
            appList.value = data.map(item => {
              var _item$extData;
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode,
                ...item.extData,
                sensitivePermission: item.sensitivePermission,
                filePath: ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-'
              };
            });
            (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
            if (autoCheck) {
              setTimeout(() => {
                var _appList$value;
                dbtIdList.value = (_appList$value = appList.value) === null || _appList$value === void 0 ? void 0 : _appList$value.map(item => item.value);
                returnChecked();
                // dbtRef.value?.onCheckAllChange({ target: { checked: true } })
              });
            }
          }
        } catch (e) {}
      },
      // 获取工作室列表数据
      getStudioList = async () => {
        try {
          const {
            code,
            data
          } = await selectByDimensionType({
            dimensionType: 'studio_group_id'
          });
          if (code === '0') {
            var _studioSelectRef$valu;
            studioList.value = data === null || data === void 0 ? void 0 : data.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode,
                ...item.extData
              };
            });
            (_studioSelectRef$valu = studioSelectRef.value) === null || _studioSelectRef$valu === void 0 || _studioSelectRef$valu.initializeOptions(studioList.value);
          }
        } catch (e) {}
      },
      // 获取渠道相关数据
      getChannel = async arr => {
        try {
          const {
            code,
            data
          } = await selectDimensionByDbtId(arr);
          if (code === '0') {
            var _data$app_version, _data$prod_id, _data$pay_chnl, _data$country, _data$pkg, _chanlSelectRef$value, _pkgSelectRef$value, _regionSelectRef$valu, _versionSelectRef$val, _prodSelectRef$value;
            verList.value = data === null || data === void 0 || (_data$app_version = data.app_version) === null || _data$app_version === void 0 ? void 0 : _data$app_version.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            prodList.value = data === null || data === void 0 || (_data$prod_id = data.prod_id) === null || _data$prod_id === void 0 ? void 0 : _data$prod_id.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName ? item.dimensionName + '(' + item.dimensionCode + ')' : item.dimensionCode,
                value: item.dimensionCode
              };
            });
            channelList.value = data === null || data === void 0 || (_data$pay_chnl = data.pay_chnl) === null || _data$pay_chnl === void 0 ? void 0 : _data$pay_chnl.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            regionList.value = data === null || data === void 0 || (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            pkgList.value = data === null || data === void 0 || (_data$pkg = data.pkg) === null || _data$pkg === void 0 ? void 0 : _data$pkg.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            (_chanlSelectRef$value = chanlSelectRef.value) === null || _chanlSelectRef$value === void 0 || _chanlSelectRef$value.initializeOptions(channelList.value);
            (_pkgSelectRef$value = pkgSelectRef.value) === null || _pkgSelectRef$value === void 0 || _pkgSelectRef$value.initializeOptions(pkgList.value);
            (_regionSelectRef$valu = regionSelectRef.value) === null || _regionSelectRef$valu === void 0 || _regionSelectRef$valu.initializeOptions(regionList.value);
            (_versionSelectRef$val = versionSelectRef.value) === null || _versionSelectRef$val === void 0 || _versionSelectRef$val.initializeOptions(verList.value);
            (_prodSelectRef$value = prodSelectRef.value) === null || _prodSelectRef$value === void 0 || _prodSelectRef$value.initializeOptions(prodList.value);
          }
        } catch (e) {}
      },
      // 各种选择器的回调处理函数
      returnStudio = arr => {
        studioChecked.value = arr;
        dbtIdList.value = [];
        getAppData(!!arr.length);
      },
      returnChecked = () => {
        getChannel(dbtIdList.value);
      },
      returnChanl = arr => {
        payChnl.value = arr;
      },
      returnRegion = arr => {
        regionIdList.value = arr;
      },
      returnVersion = arr => {
        appVersionList.value = arr;
      },
      returnPkg = arr => {
        pkgIdList.value = arr;
      },
      returnPro = arr => {
        proIdList.value = arr;
      },
      // 切换低频筛选项的展开/收起
      toggleExpand = () => {
        isExpanded.value = !isExpanded.value;
      },
      // 重置搜索条件
      resetSearch = () => {
        timeZoneType.value = 'Asia/Shanghai';
        datePeriod.value = 'day';
        dbtIdList.value = [];
        studioChecked.value = [];
        appVersionList.value = [];
        payChnl.value = [];
        proIdList.value = [];
        regionIdList.value = [];
        pkgIdList.value = [];
        pkgList.value = [];
        Object.assign(formState, {
          startTime: dayjs(new Date().getTime() - 7 * 24 * 3600 * 1000).format('YYYYMMDD'),
          endTime: dayjs(new Date().getTime() - 24 * 3600 * 1000).format('YYYYMMDD'),
          recentDay: '7-1',
          dynamic: 0,
          fromDayToDay: 0,
          useServerTime: false // true 开启服务器时间
        });
        getAppData();
        getStudioList();
        search();
      },
      // 处理时间格式转换
      handleTime = time => {
        const year = time.substring(0, 4);
        const month = time.substring(4, 6);
        const day = time.substring(6, 8);
        const date = new Date(Number(year), Number(month) - 1, Number(day));
        return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
      },
      // 执行搜索
      search = () => {
        const searchObj = {
          appVersionList: appVersionList.value,
          datePeriod: datePeriod.value,
          dbtIdList: dbtIdList.value,
          endDate: handleTime(formState.endTime),
          startDate: handleTime(formState.startTime),
          payChnl: payChnl.value,
          proIdList: proIdList.value,
          pkgList: pkgIdList.value,
          regionList: regionIdList.value,
          timeZoneType: timeZoneType.value
        };
        emit('returnSearch', searchObj);
      };
    watch(() => {
      var _userInfo$value;
      return (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.id;
    }, (n, o) => {
      if (n !== o) {
        getAppData();
        getStudioList();
        search();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_select, {
        class: "time-zone",
        placeholder: "请选择时区",
        options: zoneList,
        value: timeZoneType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => timeZoneType.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"]), _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_createTextVNode("若与海外平台对账，请切换至世界协调时间。")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "mark-icon"
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(DbtDatePicker, {
        "show-use-server-time": false,
        "show-header": false,
        "show-dynamic": false,
        startTime: formState.startTime,
        "onUpdate:startTime": _cache[1] || (_cache[1] = $event => formState.startTime = $event),
        endTime: formState.endTime,
        "onUpdate:endTime": _cache[2] || (_cache[2] = $event => formState.endTime = $event),
        recentDay: formState.recentDay,
        "onUpdate:recentDay": _cache[3] || (_cache[3] = $event => formState.recentDay = $event),
        dynamic: formState.dynamic,
        "onUpdate:dynamic": _cache[4] || (_cache[4] = $event => formState.dynamic = $event),
        fromDayToDay: formState.fromDayToDay,
        "onUpdate:fromDayToDay": _cache[5] || (_cache[5] = $event => formState.fromDayToDay = $event),
        useServerTime: formState.useServerTime,
        "onUpdate:useServerTime": _cache[6] || (_cache[6] = $event => formState.useServerTime = $event),
        position: "bottomLeft"
      }, null, 8, ["startTime", "endTime", "recentDay", "dynamic", "fromDayToDay", "useServerTime"]), _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_createTextVNode("咨询时间：客户端实际支付时间")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "mark-icon time-tips"
        })]),
        _: 1
      }), _createVNode(_component_a_select, {
        class: "time-period",
        placeholder: "请选择时间周期",
        options: periodList,
        value: datePeriod.value,
        "onUpdate:value": _cache[7] || (_cache[7] = $event => datePeriod.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtIdList.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => dbtIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "filePath",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "vertical-product-select income-product-popup income-vertical-product-popup",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: returnChecked,
        "show-bottom-border": "",
        "show-icon": true
      }, {
        icon: _withCtx(({
          option
        }) => [option.sensitivePermission === true ? (_openBlock(), _createBlock(IncomePermissionBadge, {
          key: 0
        })) : _createCommentVNode("", true)]),
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_16]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createVNode(_unref(ProductSelect), {
        ref_key: "chanlSelectRef",
        ref: chanlSelectRef,
        modelValue: payChnl.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => payChnl.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnChanl
      }, null, 8, ["modelValue", "search-fields"])])])]), _withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_hoisted_22, _createVNode(_unref(ProductSelect), {
        ref_key: "studioSelectRef",
        ref: studioSelectRef,
        modelValue: studioChecked.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => studioChecked.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnStudio
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_unref(ProductSelect), {
        ref_key: "pkgSelectRef",
        ref: pkgSelectRef,
        modelValue: pkgIdList.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => pkgIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnPkg
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_25, [_hoisted_26, _createVNode(_unref(ProductSelect), {
        ref_key: "regionSelectRef",
        ref: regionSelectRef,
        modelValue: regionIdList.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => regionIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnRegion
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createVNode(_unref(ProductSelect), {
        ref_key: "versionSelectRef",
        ref: versionSelectRef,
        modelValue: appVersionList.value,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => appVersionList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnVersion
      }, null, 8, ["modelValue", "search-fields"])]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createVNode(_unref(ProductSelect), {
        ref_key: "prodSelectRef",
        ref: prodSelectRef,
        modelValue: proIdList.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => proIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": false,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": false,
        layout: "horizontal",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "revenue-product-select",
        placeholder: "请选择",
        onChange: returnPro
      }, null, 8, ["modelValue", "search-fields"])])])], 512), [[_vShow, isExpanded.value]])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("span", {
        class: "expand-btn",
        onClick: toggleExpand
      }, [_createTextVNode(_toDisplayString(isExpanded.value ? '收起' : '展开更多') + " ", 1), _createVNode(_unref(DownOutlined), {
        class: _normalizeClass(['expand-icon', {
          'is-expanded': isExpanded.value
        }])
      }, null, 8, ["class"])]), _createVNode(_component_a_button, {
        onClick: resetSearch
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});